import { SystemBase } from "@inter-ikea-core/core-toolbox";
import ReplaceEntityComponent from "../components/ReplaceEntityComponent";
import logEmptyFunctionWarning from "../functions/logEmptyFunctionWarning";
import { replaceEntity } from "../functions/sideUnitReplacement";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
export class EntityReplacementSystem extends SystemBase {
    constructor(productManager, coreServices) {
        super(ReplaceEntityComponent.id);
        this.productManager = productManager;
        this.coreServices = coreServices;
        this.doingChangesOnComponent = [];
        this.id = "EntityReplacementSystem";
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        const replaceEntityComponent = _entity.getComponent(COMPONENT_IDS.REPLACE_ENTITY);
        if (!replaceEntityComponent ||
            !replaceEntityComponent.replacementProductRef)
            throw new Error("Replacement productRef was not set.");
        replaceEntity(_entity, replaceEntityComponent.replacementProductRef, [], this.productManager, this.coreServices);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        logEmptyFunctionWarning("onUpdateComponent", this.id);
    }
    onRemoveComponent(_entity, _oldComponent) {
        logEmptyFunctionWarning("onRemoveComponent", this.id);
    }
}
